// src/components/JoinEarlyBox.jsx
import React from 'react';
import './JoinEarlyBox.css';

const JoinEarlyBox = ({ message = "🕒 One Day You’ll Say – “I Was Part of VORTREX From Day One”" }) => {
  return (
    <div className="join-early-box">
      <span>{message}</span>
    </div>
  );
};

export default JoinEarlyBox; // ✅ DEFAULT EXPORT
